import type { ComponentMetaInput } from '../../ui';

const definitions = [
  ['displaySettings', 'container', '语音回复显示'], ['displayTitle', 'text', '语音回复显示标题'],
  ['waitLabel', 'text', '语音生成后再显示文字'], ['waitToggle', 'input', '等待语音开关'],
  ['bubbleLabel', 'text', '启用语音气泡'], ['bubbleToggle', 'input', '语音气泡开关'], ['displayHint', 'text', '语音显示说明'],
  ['root', 'container', 'MiMo 语音页'], ['title', 'text', 'MiMo 语音'],
  ['account', 'text', '语音订阅状态'], ['refresh', 'button', '刷新账户'],
  ['plans', 'list', '语音套餐'], ['plan', 'container', '套餐条目'], ['planName', 'text', '套餐名称'],
  ['planPrice', 'text', '套餐价格与时长'], ['buy', 'button', '购买套餐'],
  ['confirm', 'modal', '确认钱包扣款'], ['confirmTitle', 'text', '购买确认标题'],
  ['confirmText', 'text', '钱包扣款及即时到期说明'], ['confirmBuy', 'button', '确认扣款'], ['cancelBuy', 'button', '取消购买'],
  ['settings', 'container', '独立音色设置'], ['tabs', 'nav', '音色设置标签'], ['tab', 'button', '音色设置标签按钮'],
  ['presetLabel', 'text', '预设音色'], ['preset', 'input', '预设音色选择'], ['presetOption', 'text', '预设音色选项'],
  ['designLabel', 'text', '音色设计描述'], ['design', 'input', '音色设计描述输入'],
  ['cloneLabel', 'text', '复刻指令描述'], ['clone', 'input', '复刻指令描述输入'],
  ['consentLabel', 'text', '音色授权声明'], ['consent', 'input', '音色授权确认'],
  ['referenceLabel', 'text', '参考音频上传'], ['reference', 'input', '参考音频文件'],
  ['referenceName', 'text', '此设备参考音频'], ['referenceAudio', 'container', '本地参考音频播放器'],
  ['removeReference', 'button', '单独删除参考音频'], ['save', 'button', '保存独立音色设置'],
  ['preview', 'container', '音色试听'], ['previewLabel', 'text', '试听文本'], ['previewText', 'input', '试听文本输入'],
  ['synthesize', 'button', '生成试听'], ['previewAudio', 'container', '本地试听播放器'],
  ['cleanup', 'button', '清理未关联试听及过期本地音频'], ['retry', 'button', '重试音频保存确认'],
  ['status', 'text', '语音操作状态'], ['selector', 'input', '聊天语音模式下拉框'],
] as const;

export const MIMO_COMPONENTS: ComponentMetaInput[] = definitions.map(([name, role, label], index) => ({
  id: `mimo.${name}`, page: name === 'selector' ? 'chat' : 'tts', role, label,
  layout: name === 'selector' ? { x: 24, y: 280, width: 342, height: 44 }
    : { x: name === 'root' ? 0 : 16, y: name === 'root' ? 24 : 36 + (index % 15) * 48, width: name === 'root' ? 390 : 358, height: name === 'root' ? 744 : 44 },
  zIndex: name.startsWith('confirm') || name === 'cancelBuy' ? 20 : 2,
  props: ['disabled', 'value', 'state'], notes: '流式滚动布局；重复条目追加实例 ID。安卓使用对应原生控件。',
}));
export function mimoMeta(id: string): ComponentMetaInput {
  const meta = MIMO_COMPONENTS.find((candidate) => candidate.id === `mimo.${id}`);
  if (!meta) throw new Error(`Unknown MiMo component: ${id}`);
  return meta;
}
